import React from "react";
import { Page, List, ListItem, Icon } from "react-onsenui";
import TutorialPage from "../pages/TutorialPage";
import AboutUsPage from "../pages/AboutUsPage";

// import protest_logo from "../assets/protest.png";
// import wolnamolekula_logo from "../assets/wolnamolekula.png";

const style = {
  footer: {
    position: "absolute",
    bottom: 0,
    marginLeft: "10px",
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  logoBox: {
    textAlign: "center",
    margin: "10px 0"
  },
  logo: {
    height: "50px"
  },
  logoLink: {
    color: "#000",
    textDecoration: "none",
    fontSize: 16,
    fontWeight: "bold"
  }
};

const menuItems = [
  {
    name: "Get a test kit",
    link: "https://protestkit.eu/"
  },
  {
    name: "Drug checking services",
    link: "https://protestkit.eu/drug-checking-services/"
  },
  {
    name: "Pill testing results",
    link: "https://protestkit.eu/database-of-pill-reports/"
  },
  {
    name: "Support forum",
    link: "https://www.reddit.com/r/ReagentTesting/"
  },
  {
    name: "Tutorial",
    pushPage: TutorialPage,
    key: "TutorialPage"
  },
  {
    name: "About Us",
    pushPage: AboutUsPage,
    key: "AboutUsPage"
  }
];

export default class HamburgerMenu extends React.Component {
  handleItemClick(menuItem) {
    if (menuItem.link) return window.open(menuItem.link);
    if (menuItem.pushPage) return this.pushPage(menuItem);
  }

  pushPage(menuItem) {
    this.props.hideMenu();
    this.props.navigator.pushPage({
      component: menuItem.pushPage,
      props: {
        key: menuItem.key
      }
    });
  }

  renderListRow(menuItem, index) {
    return (
      <ListItem
        key={index}
        className="clickable blue"
        tappable={true}
        onClick={() => this.handleItemClick(menuItem)}
      >
        {menuItem.link && (
          <Icon icon="external-link" size={16} style={{ marginRight: 6 }} />
        )}
        {menuItem.name}
      </ListItem>
    );
  }

  render() {
    return (
      <Page>
        <List
          dataSource={menuItems}
          renderRow={this.renderListRow.bind(this)}
        />

        <div style={style.footer}>
          <div style={style.logoBox}>
            <a
              style={style.logoLink}
              href="https://www.protestkit.eu/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* <img src={protest_logo} alt="PRO Test" style={style.logo} /> */}
              <br />
              MADE BY
            </a>
          </div>
          <div style={style.logoBox}>
            <a
              style={style.logoLink}
            >
              <img
                // src={wolnamolekula_logo}
                alt="Wolna Molekuła"
                style={style.logo}
              />
              <br />
              POWERED BY
            </a>
          </div>
        </div>
      </Page>
    );
  }
}
